<template>
    <!--TODO need to fix this np-responsive. the $attrs keep binding to the np-responsive-->
    <np-responsive v-if="hasAddon()">
        <template #label>
            <span>{{label}}</span>
        </template>
        <template #input>
        <div class="form-group input-group">
            <div class="input-group-prepend" style="cursor: pointer" v-if="hasAddon() && addonOnLeft" @click="$emit('addon-click', modelValue)">
                <div class="input-group-text">
                    <slot name="addon"></slot>
                </div>
            </div>
            <div class="input-group-prepend" style="cursor: pointer" v-if="hasExtraAddon()" @click="$emit('addon2-click', modelValue)">
                <div class="input-group-text">
                    <slot name="addon2"></slot>
                </div>
            </div>
            <input v-if="noTyping" :class="[{pickerEnabled : noTyping && !readonly}, addClass]"
                   :readonly="readOnlyInput"
                   @touch="showDatePicker()"
                   @focus="showDatePicker()"
                   @focusout="hideDatePicker()"
                   ref='input'
                   :value="defFormatter(modelValue)"
                   v-bind=$attrs
                   :required="isRequired"
                   :aria-label="label"/>
            <input v-if="formatter" :value="formatter(modelValue)" @input="onKeyEnter"  @focusout="hideDatePicker()" :required="isRequired" v-bind=$attrs />
            <input v-else :value="modelValue"  :date-format="dateFormat" @input="onKeyEnter"  @focusout="hideDatePicker()" :required="isRequired" v-bind=$attrs />
            <div class="input-group-append" :class="addonClass" style="cursor: pointer" v-if="hasAddon() && !addonOnLeft"
                 @click="$emit('addon-click', modelValue)">
                <div class="input-group-text">
                    <slot name="addon"></slot>
                </div>
            </div>
        </div>
        </template>
    </np-responsive>
    <input v-else-if="noTyping" :class="[{pickerEnabled : noTyping && !readonly}, addClass]"
           :readonly="readOnlyInput"
           ref='input'
           @touch="showDatePicker()"
           @focus="showDatePicker()"
           @focusout="hideDatePicker()"
           :value="defFormatter(modelValue)"
           v-bind=$attrs
           :required="isRequired"
           :aria-label="label"/>
        <input v-else-if="formatter" :value="formatter(modelValue)" @input="onKeyEnter" @focusout="hideDatePicker()" :required="isRequired" v-bind=$attrs />
        <input v-else :value="modelValue"  :date-format="dateFormat" @input="onKeyEnter" @focusout="hideDatePicker()" :required="isRequired" v-bind=$attrs />

</template>
<!--TODO: Make date picker register empty input as an input value-->
<script>
    import locale from '../mixins/locale';
    import npResponsive from "./np-responsive.vue";
    export default  {
        name: 'np-date-picker',
        components: {
            'np-responsive': npResponsive,
        },
        props: {
            mixins: [locale],
            modelValue: String,
            addonOnLeft: {
                default: false
            },
            addonClass: {
                type: Object,
                default: function () {
                    return {}
                }
            },
            label: '',
            readonly: {
                default: false
            },
            noTyping: {
                default: true
            },
            disallowPast: {
                default: false
            },
            allowClear: {
                default: false
            },
            required: {
                default: true,
            },
            check_config: {
                default: true
            },
            disallowFuture: {
                default: false
            },
            endDate: {
                type: String,
                default: function () {
                    return ''
                }
            },
            startDate: {
                type: String,
                default: function () {
                    return '01-01-1900'
                }
            },
            hasStartDate: {
                type: Boolean,
                default: function (){
                    return true
                }
            },
            dateFormat: {
                type: String,
                default: function () {
                    return ''
                }
            },
            addClass: {
                default: ''
            },
            rules: {
                type: Array,
                default: function () {
                    return [];
                }
            },
            formatter: Function
            //noWrapper: Boolean
        },
        data: function () {
            return {
                page_config_required: false,
                settings: {
                    autoclose: true,
                    enableOnReadonly: true,
                    dateFormat: 'dd-mm-yyyy',
                    format: 'dd-mm-yyyy',
                },
                default_readonly: false,
                previous_value: '',
                activeEdit: false,
                onload_value: '',
                emit_on_update: false,
                mouse_not_up: false,
            }
        },
        computed: {
            isUSDate() {
                return this.dateFormat === 'en-US'
            },
            readOnlyInput: function () {
                return this.noTyping && this.readonly;
            },
            inputRef: function() {
                return this.$refs.input;
            },
            isRequired: function () {
                return this.check_config ? !!this.page_config_required : !!this.required;
            }
        },
        mounted: function () {
            let vm = this;
            if (this.isUSDate) {
                this.datepickerFormat = 'mm/dd/yyyy';
                // this.settings['dateFormat'] = 'mm/dd/yyyy';
                this.settings['format'] = 'mm/dd/yyyy';
            }

            if (this.endDate !== '') {
                this.settings['endDate'] = this.endDate;
            }

            let lang_code = $('[data-language-code]').data('language-code').substring(0, 2);
            this.settings['language'] = lang_code;


            // if (this.endDate !== '') {
            //     if(this.endDate === 'yesterday')
            //         $(this.$el).datepicker('setEndDate', "yesterday");
            //     if(this.endDate === 'today')
            //         $(this.$el).datepicker('setEndDate', "today");
            //     else
            //         this.settings['endDate'] = this.endDate;
            // }
            // // TODO set endDate directly otherwise today cannot be selected
            // else if (this.disallowFuture) {
            //     $(this.$el).datepicker('setEndDate', "yesterday");
            // }


            //TODO: Pay attention to the date format need to be alligned withe alliance data format. overrite settings
            //TODO: below, at setDateFormatByTenantConfig()
            if (this.startDate !== '' && !!this.hasStartDate  && !this.disallowPast) {
                this.settings['startDate'] = this.startDate;
            }

            if (this.disallowFuture && this.endDate === '') {
                this.settings['endDate'] = "0d"; //this.startDate;
                // $(this.$el).datepicker('setEndDate', "now()");
            }
            if (this.disallowPast && this.startDate !== '+1d') {
                this.settings['startDate'] = "0d"; //this.startDate;
                // $(this.$el).datepicker('setStartDate', "now()");
            }
            else if(this.startDate === '+1d')
            {
                this.settings['startDate'] = this.startDate
            }

            this.settings['enableOnReadonly'] = !this.readonly;

            if(this.allowClear) {
                this.settings['clearBtn'] = true;
            }

            this.setDateFormatByTenantConfig();

            this.init();
        },
        methods: {
            formatDateByTenantMask: function(date_value) {
                // data value can be default format or tenant format, output will reverse the data if the default
                // format differ from the tenant format
                //console.log('formatDateByMask');
                let vm = this;
                let mask_format = vm.settings['format'];
                let default_format = 'dd-mm-yyyy';

                if (default_format === mask_format) {
                    return date_value;
                }

                let date_value_sections = date_value !== undefined ? date_value.split('-') : [];
                let has_all_date_sections = date_value_sections.length === 3;

                if (has_all_date_sections) {
                    let mask_format_sections = {};
                    let default_format_sections = {};

                    //initialize sections 0000
                    default_format.split('-').forEach((section, index) => {
                        default_format_sections[section] = date_value_sections[index];
                    });

                    mask_format.split('-').forEach(section => {
                        mask_format_sections[section] = default_format_sections[section];
                    });

                    //update date_value with respect to mask format
                    date_value = '';

                    Object.values(mask_format_sections).forEach((section_value, index) => {
                        date_value += index < 2 ? `${section_value}-` : `${section_value}`;
                    })

                }

                return date_value;

            },
            reverseFormatDateByMask: function(date_value) {
                //console.log('reverseFormatDateByMask');

                let vm = this;
                let date_value_sections = date_value !== undefined ? date_value.split('-') : [];
                let has_all_date_sections = date_value_sections.length === 3;

                if (has_all_date_sections) {

                    let mask_format = vm.settings['format'];
                    let mask_format_sections = {};

                    let default_format = 'dd-mm-yyyy';
                    let default_format_sections = {};

                    //initialize sections 0000
                    mask_format.split('-').forEach((section, index) => {
                        mask_format_sections[section] = date_value_sections[index];
                    });

                    default_format.split('-').forEach(section => {
                        default_format_sections[section] = mask_format_sections[section];
                    });

                    //update date_value with respect to default format
                    date_value = '';

                    Object.values(default_format_sections).forEach((section_value, index) => {
                        date_value += index < 2 ? `${section_value}-` : `${section_value}`;
                    })

                }

                return date_value;

            },
            setDateFormatByTenantConfig: function() {
                let vm = this;
                //console.log('Tenant', vue_data)

                let tenant_format = $('body').data('date-format');
                if (typeof tenant_format === 'undefined') {
                    tenant_format = 'ddmmyyyy';
                }
                //console.log('updated:=>',tenant_format)

                if (tenant_format !== '') {
                    for(let char_pos = 0; char_pos < (tenant_format.length - 1); char_pos++) {
                        let current_char = tenant_format[char_pos];
                        let next_char = tenant_format[char_pos+1];

                        let has_separator = current_char === '-' || next_char === '-'

                        if (current_char !== next_char && !has_separator ) {
                            tenant_format = tenant_format.replace(`${current_char}${next_char}`,
                                `${current_char}-${next_char}`);
                        }
                    }

                    //console.log('updated:=>', tenant_format);
                    vm.settings['dateFormat'] = tenant_format;
                    vm.settings['format'] = tenant_format;

                    //TODO: Check if start date is a valid data
                    vm.settings['startDate'] = vm.formatDateByTenantMask(vm.settings['startDate']);


                    // console.log('updated:=>',this.settings);
                }

            },
            init: function () {
                $.fn.selectRange = function(start, end) {
                    if(end === undefined) {
                        end = start;
                    }
                    return this.each(function() {
                        if('selectionStart' in this) {
                            this.selectionStart = start;
                            this.selectionEnd = end;
                        } else if(this.setSelectionRange) {
                            this.setSelectionRange(start, end);
                        } else if(this.createTextRange) {
                            var range = this.createTextRange();
                            range.collapse(true);
                            range.moveEnd('character', end);
                            range.moveStart('character', start);
                            range.select();
                        }
                    });
                };

                $.fn.getCaret = function(n) {
                    var input = this.get(0);
                    if (!input) return; // No (input) element found
                    if (document.selection) {
                        // IE
                        input.focus();
                    }
                    return 'selectionStart' in input ? input.selectionStart:'' || Math.abs(document.selection.createRange().moveStart('character', -input.value.length));

                    // var d = $(this)[0];
                    // var s, r;
                    // r = document.createRange();
                    // r.selectNodeContents(d);
                    // s = window.getSelection();
                    // console.log('position: '+s.anchorOffset+' of '+s.anchorNode.textContent.length);
                    // return s.anchorOffset;
                };

                $.fn.setCaret = function(n) {
                    var d = $(this)[0];
                    d.focus();
                    var r = document.createRange();
                    var s = window.getSelection();
                    r.setStart(d.childNodes[0], n);
                    r.collapse(true);
                    s.removeAllRanges();
                    s.addRange(r);
                    console.log('position: '+s.anchorOffset+' of '+s.anchorNode.textContent.length);
                    return this;
                };

                let vm = this;
                const dateValue = this.modelValue;//vm.formatDateByMask(this.value); // ? this.formatDate(this.value) : '';
                vm.previous_value = vm.modelValue === '' ? vm.settings['format'] : vm.formatDateByTenantMask(this.modelValue);
                vm.onload_value = vm.previous_value; // vm.value;

                // Implement the mutation of a date from the api according to the tenant date format.
                let init_date_emit = vm.formatDateByTenantMask(this.modelValue);
                let initialEmitDone = new Promise((resolve) => {
                    if(vm.$emit('update:modelValue', init_date_emit)) {
                        resolve()
                    }
                })
                initialEmitDone.then(() => {
                    vm.emit_on_update = true;
                });

                $(this.inputRef).datepicker(this.settings)
                    .val(dateValue)
                    .on('changeDate', function (evt) {
                        // const isoDate = this.value ? vm.formatDateToISO(this.value) : '';
                        $(this).triggerHandler("focus");
                        // console.log(isoDate)
                        let incomplete_date = ['y', 'm', 'd'].some(section => {
                            return this.value.includes(section);
                        })
                        let reverse_formatted_date = incomplete_date ? vm.onload_value : this.value;
                        vm.changeValue(reverse_formatted_date)
                        vm.activeEdit = false;
                        $(this.inputRef).datepicker('hide')
                    })
                    .on('input', (event) => {
                        let allowed_separators = [',', '/', '\\', '.', '-', ' '],
                            newValue = event.originalEvent.data,
                            is_number = parseInt(newValue) > -1,
                            is_separator = allowed_separators.includes(newValue);

                        if (!vm.mouse_not_up) {
                            if (is_number || is_separator) {

                                if (is_separator) {
                                    vm.jumpToNextSection(vm, event);
                                } else if (is_number) {
                                    vm.processNewInput(vm, event)
                                }

                                $(this).triggerHandler("focus");
                            }
                        } else {
                            // console.log(`Stop Long Pressing Mouse`);
                            this.changeValue(vm.previous_value)
                        }
                    })
                    .on('keydown', (event) => {
                        const key = event.key; // const {key} = event; ES6+
                        //console.log('Keydown:=>', key, event, vm)
                        let section_jumper_right = ['ArrowRight', 'Spaceback'].includes(key),
                            section_jumper_left = ['Backspace', 'ArrowLeft'].includes(key);

                        if (!vm.mouse_not_up) {
                            if (section_jumper_right && section_jumper_left) {
                                event.preventDefault();
                                event.originalEvent.data = '/';

                                if (section_jumper_right) {
                                    vm.jumpToNextSection(vm, event);
                                }

                            } else {
                                let allowed_separators = [',', '/', '\\', '.', '-', ' '],
                                    is_number = parseInt(key) > -1,
                                    is_separator = allowed_separators.includes(key);

                                if (!is_number && !is_separator) {
                                    event.preventDefault();
                                }
                            }
                        } else {
                            // console.log(`Stop Long Pressing Mouse`);
                            this.changeValue(vm.previous_value)
                        }
                    })
                    .on('click', (event) => {
                        $(this.inputRef).datepicker('show');
                        if (!vm.activeEdit) {
                            let formatted_value = vm.modelValue === '' ? vm.settings['format'] : vm.modelValue;//vm.formatDateByMask(vm.value);
                            let f_sec = vm.settings['format'].split('-')[0],
                                f_val = formatted_value;
                            let done = new Promise((resolve, reject) => {
                                if(!!f_val) {
                                    vm.changeValue(`${f_sec}${f_val.slice(f_val.length - (f_val.length - f_sec.length))}`);
                                    resolve();
                                }
                            });

                            done.then(() => {
                                vm.adjustCaretPosition(event, 0, f_sec.length);
                            });
                            vm.activeEdit = true;

                            //set onLoad value from this
                            let reverse_formatted_date = this.value;
                            vm.onload_value = reverse_formatted_date;
                        } else {
                            //detect cursor position and determine section
                            // replace contents of section with representative mask
                            // highlight contents of section
                            vm.onClickSectionSelect(vm, event);
                        }
                    })
                    .on('blur', (event) => {
                        //console.log('Blur:=> Click away');

                        let value_on_ui = $(`#${vm.inputRef.id}`).val();
                        // console.log(`Value on UI`, value_on_ui)
                        //value on UI has already been validated by date picker at this point
                        vm.changeValue(value_on_ui);
                        vm.activeEdit = false;

                    })
                    //prevent multi-text selection text
                    .on('mousedown', (event) => {
                        //console.log("mousedown on", event.pageX);
                        vm.mouse_not_up = true;
                    })
                    .on('mouseup', (event) => {
                        //console.log("mouseup on", event.pageX);
                        vm.mouse_not_up = false;
                    });

            },
            changeValue(value) {
                if(!!value){
                    this.$emit('update:modelValue', value);
                    this.$emit('input', value);
                }
            },
            jumpToNextSection: (vm, event, reverse=false) => {

                let set_caret_pos = false;
                let caret_start_pos = 0;
                let caret_end_pos = 0;

                let newValue = event.originalEvent.hasOwnProperty('data') ? event.originalEvent.data : '';
                let idSelector = '#'+event.originalEvent.target.id;

                let section_format = vm.settings['format'].split('-')
                let section_value = vm.previous_value.split('-');

                if (section_value.length > 3) {
                    //the `-` separator was added look for --
                    section_value = $(idSelector).val().replace('--', '/-').split('-');
                    newValue = newValue === '-' ? '/' : newValue;
                }

                let section = {};
                section.section_1_format = section_format[0];
                section.section_2_format = section_format[1];
                section.section_3_format = section_format[2];

                section.section_1_value = section_value[0];
                section.section_2_value = section_value[1];
                section.section_3_value = section_value[2];

                let secs = [1,2,3];
                let mask_chars = ['d', 'm', 'y']

                //new character position : caret position - 1
                let pos = vm.getCaretPosition(event) - 1;

                let space_format_count = 0;
                let space_value_count = 0;
                let active_key_value = '';
                let active_section_value = '';

                let done = new Promise((resolve, reject) => {

                    secs.forEach(sec => {
                        let key_format = `section_${sec}_format`;
                        let key_value = `section_${sec}_value`;
                        let next_key_format = `section_${sec+1}_format`;
                        let next_key_value = `section_${sec+1}_value`;

                        let section_format_len_and_space = sec === 3
                            ? section[key_format].length
                            : 1 + section[key_format].length;
                        space_format_count += section_format_len_and_space;

                        let section_value_len_and_space = sec === 1
                            ? section[key_format].length
                            : 1 + section[key_format].length;
                        space_value_count += section_value_len_and_space;

                        let caret_in_section = pos < space_value_count || pos === space_value_count;

                        if (caret_in_section && !set_caret_pos) {
                            active_key_value = key_value;
                            active_section_value = section[key_value].replace(newValue, '');

                            set_caret_pos = true;
                            caret_start_pos = space_format_count;
                            caret_end_pos = caret_start_pos + section[next_key_format].length;//make this distance same as length of section

                            let can_jump_section = sec !== 3;

                            //replace content of next section with mask
                            if (can_jump_section) {
                                section[next_key_value] = section[next_key_format];
                            }
                        }
                    })

                    if (Object.keys(section).includes(active_key_value)) {
                        section[active_key_value] = active_section_value;
                    }

                    this.changeValue(`${section.section_1_value}-${section.section_2_value}-${section.section_3_value}`);
                    //set value as previous value
                    vm.previous_value = `${section.section_1_value}-${section.section_2_value}-${section.section_3_value}`;

                    resolve('success!');

                    // setTimeout(() => {
                    //     resolve('success!');
                    // }, 5);
                })

                if (set_caret_pos) {
                    done.then((val) => {
                        //console.log('Rofter:=>', val, event, caret_start_pos, caret_end_pos);
                        vm.adjustCaretPosition(event, caret_start_pos, caret_end_pos);
                    })
                }
            },
            processNewInput: (vm, event) => {

                let set_caret_pos = false;
                let caret_start_pos = 0;
                let caret_end_pos = 0;

                let newValue = event.originalEvent.data;
                let idSelector = '#'+event.originalEvent.target.id;
                let section_format = vm.settings['format'].split('-');
                let field_content = vm.getFieldContents(idSelector, newValue);//$(idSelector).val()
                let section_value = field_content.split('-');

                let section = {};
                section.section_1_format = section_format[0];
                section.section_2_format = section_format[1];
                section.section_3_format = section_format[2];

                section.section_1_value = section_value[0];
                section.section_2_value = section_value[1];
                section.section_3_value = section_value[2];

                let secs = [1,2,3];
                let mask_chars = ['d', 'm', 'y']

                //new character position : caret position - 1
                let pos = vm.getCaretPosition(event) - 1;
                let space_format_count = 0;
                let space_value_count = 0;
                let active_key_value = '';
                let active_section_value = '';

                let done = new Promise((resolve, reject) => {

                    secs.forEach(sec => {
                        let key_format = `section_${sec}_format`;
                        let key_value = `section_${sec}_value`;
                        let next_key_format = `section_${sec+1}_format`;
                        let next_key_value = `section_${sec+1}_value`;

                        let section_format_len_and_space = sec === 1
                            ? section[key_format].length
                            : 1 + section[key_format].length;
                        space_format_count += section_format_len_and_space;

                        let section_value_len_and_space = sec === 1
                            ? section[key_format].length
                            : 1 + section[key_format].length;
                        space_value_count += section_value_len_and_space;

                        let caret_in_section = pos < space_value_count || pos === space_value_count;

                        if (caret_in_section && !set_caret_pos) {
                            let previous_value_sections = vm.previous_value.split('-');
                            let old_value_key = sec - 1;

                            active_section_value = `${section[key_value]}`;//`${previous_value_sections[old_value_key]}${newValue}`;

                            if (active_section_value.length < section[key_format].length) {
                                //padding missing length with 0s at front
                                let deficit = section[key_format].length - active_section_value.length;

                                for (let count = 0; count < deficit; count++) {
                                    active_section_value = `${section[key_format][0]}${active_section_value}`;
                                }
                            }

                            //trim process set equal length to mask
                            let slice_factor = active_section_value.length - section[key_format].length;
                            active_section_value = active_section_value.slice(slice_factor);

                            //replace mask characters with 0s
                            let section_complete = true;
                            mask_chars.forEach(char => {
                                if (active_section_value.includes(char)) {
                                    //active_section_value = active_section_value.replaceAll(char, '0');
                                    section_complete = false;
                                }
                            })

                            //reset date section values if invalid given
                            if (section_complete) {
                                if (section[key_format].includes('d')) {
                                    //day
                                    active_section_value = active_section_value > 31 ? 28 : active_section_value;
                                } else if (section[key_format].includes('m')) {
                                    //month
                                    active_section_value = active_section_value > 12 ? 12 : active_section_value;
                                } else if (section[key_format].includes('y')) {
                                    //year
                                }

                            }

                            let can_jump_section = section_complete && sec !== 3;

                            active_key_value = key_value;

                            set_caret_pos = true;
                            caret_start_pos = can_jump_section ? space_format_count + 1 : space_format_count;
                            caret_end_pos = can_jump_section ? caret_start_pos + section[next_key_format].length : caret_start_pos;

                            //replace content of next section with mask
                            if (can_jump_section) {
                                section[next_key_value] = section[next_key_format];
                            }
                        }
                    })

                    if (Object.keys(section).includes(active_key_value)) {
                        section[active_key_value] = active_section_value;
                    }

                    vm.changeValue(`${section.section_1_value}-${section.section_2_value}-${section.section_3_value}`);
                    //set value as previous value
                    vm.previous_value = `${section.section_1_value}-${section.section_2_value}-${section.section_3_value}`;

                    resolve('success!');

                    // setTimeout(() => {
                    //     resolve('success!');
                    // }, 5);

                });

                if (set_caret_pos) {
                    done.then((val) => {
                        vm.adjustCaretPosition(event, caret_start_pos, caret_end_pos);
                    })
                }
            },
            onClickSectionSelect: (vm, event) => {

                let set_caret_pos = false;
                let caret_start_pos = 0;
                let caret_end_pos = 0;

                let idSelector = '#'+event.originalEvent.target.id;

                let section_format = vm.settings['format'].split('-')
                let section_value = $(idSelector).val().split('-');

                let section = {};
                section.section_1_format = section_format[0];
                section.section_2_format = section_format[1];
                section.section_3_format = section_format[2];

                section.section_1_value = section_value[0];
                section.section_2_value = section_value[1];
                section.section_3_value = section_value[2];

                let done = new Promise((resolve, reject) => {

                    let secs = [1,2,3];
                    let mask_chars = ['d', 'm', 'y']

                    //new caret position
                    let pos = vm.getCaretPosition(event);
                    let space_format_count = 0;
                    let space_value_count = 0;
                    let active_key_value = '';
                    let active_section_value = '';

                    secs.forEach(sec => {
                        let key_format = `section_${sec}_format`;
                        let key_value = `section_${sec}_value`;
                        let next_key_format = `section_${sec+1}_format`;
                        let next_key_value = `section_${sec+1}_value`;

                        let section_format_len_and_space = sec === 3
                            ? section[key_format].length
                            : section[key_format].length + 1;
                        space_format_count += section_format_len_and_space;

                        let section_value_len_and_space = sec === 3
                            ? section[key_format].length
                            : section[key_format].length + 1;
                        space_value_count += section_value_len_and_space;

                        let caret_in_section = pos < space_value_count || pos === space_value_count;

                        if (caret_in_section && !set_caret_pos) {

                            active_section_value = `${section[key_format]}`;

                            active_key_value = key_value;

                            set_caret_pos = true;
                            caret_start_pos = space_format_count - section_format_len_and_space;
                            caret_end_pos = caret_start_pos + section[key_format].length;
                        }
                    })

                    if (Object.keys(section).includes(active_key_value)) {
                        section[active_key_value] = active_section_value;
                    }

                    vm.changeValue(`${section.section_1_value}-${section.section_2_value}-${section.section_3_value}`);
                    //set value as previous value
                    vm.previous_value = `${section.section_1_value}-${section.section_2_value}-${section.section_3_value}`;

                    resolve('success!');
                });

                if (set_caret_pos) {
                    done.then((val) => {
                        vm.adjustCaretPosition(event, caret_start_pos, caret_end_pos);
                    })
                }
            },
            adjustCaretPosition: (event, start=0, end=0) => {
                if (start > -1) {
                    let idSelector = '#'+event.originalEvent.target.id;
                    //console.log('adjustCaretPosition:=>', idSelector, start, end)
                    $(idSelector).selectRange(start, end);
                }
            },
            getCaretPosition: (event) => {
                let idSelector = '#'+event.originalEvent.target.id;
                let pos = $(idSelector).getCaret();

                //console.log('getCaretPosition:=>', idSelector, pos);
                return pos;
            },
            showDatePicker: function () {
                $(this.inputRef).datepicker('show');
                $(this.inputRef).tooltip('dispose');
            },
            hideDatePicker: function ($event) {
                setTimeout(function () {
                    $(this.inputRef).datepicker('hide')
                }, 500)
            },
            defFormatter: function (value) {
                if (!!this.formatter) {
                    return this.formatter(value)
                }
                return value
            },
            //this function exists because of issue ELV 410.
            // the this.value doesn't change when the user keys in the date. So you might see change on
            // the UI but the data isn't changed.
            onKeyEnter: function ($event) {
                this.changeValue($event.target.value);
            },
            hasAddon: function () {
                return !!this.$slots.addon;
            },
            hasExtraAddon: function () {
                return !!this.$slots.addon2;
            },
            convertUKDateTOUSDate(input) {
                var datePart = input.match(/\d+/g),
                    day = datePart[0].substring(2), // get only two digits
                    month = datePart[1],
                    year = datePart[2];

                return month + '/' + day + '/' + year;
            },
            assignRules: function () {
                if (this.rules.length > 0) {
                    this.rules.forEach(rule => {
                        if (typeof rule === 'string') {
                            this.inputRef.setAttribute(`data-rule-${rule}`, '');
                        } else {
                            for (const [key, value] of Object.entries(rule)) {
                                let excluded = ['maxlength', 'minlength', 'min', 'max'];
                                const rule_key = (excluded.findIndex(obj => {
                                    return obj === key
                                }) > -1) ? key : `data-rule-${key}`;
                                if (typeof value === 'string') {
                                    this.inputRef.setAttribute(rule_key, `${value}`);
                                } else {
                                    if (value.hasOwnProperty('remove') && value.remove === true) {
                                        if (this.inputRef.hasAttribute(rule_key)) {
                                            this.inputRef.removeAttribute(rule_key)
                                            $(this.inputRef).rules('remove', key)
                                        }
                                    }
                                }
                            }
                        }
                    })
                }
            },
            getFieldContents: function(idSelector, newValue) {
                let vm = this,
                    actual_field_value = $(idSelector).val();

                //console.log(`actual_contn`, actual_field_value, actual_field_value.length);
                /*
                *  if the date is not complete, add a "-" tp the end of inserted value
                */
                if (!actual_field_value.includes('-')) {
                    return vm.previous_value.replace('-',`${newValue}-`)
                }
                return actual_field_value

            }
        },
        watch: {
            modelvalue: function (newValue, oldValue) { // Property of vue watch takes up to 2 arguments
                let vm = this;
                // console.log("New value is:" , newValue, "Old value is:" , oldValue, "Formatted value is",
                //     vm.formatDateByTenantMask(newValue),vm.formatDateByTenantMask(newValue) == oldValue)
                //trigger point:
                //1. Refresh page, enter into init function. Init function trigger a input event by the tenant format data
                // old value is the api default mode (dd-mm-yyyy), new value is tenant format date
                //2. Change date in the component (select or type). vue model value changed within this component,
                // old value and new value are tenant format. date could contain mask characters
                //3. The vue-model property value was changed from outside this component. eg. mutation at parent component
                //4. Click Save. which is the same as case (3) eg. Vue.set()
                // old value is API default mode. new value is tenant format date

                // Check whether the value has been updated/mutated with the api date format  //dd-mm-yyyy
                let is_same_data = newValue === oldValue;
                let not_same_data_but_convertible_by_mask = !is_same_data && (vm.formatDateByTenantMask(newValue) === oldValue);

                // Update value if the date has not been inverted
                if (!is_same_data && !not_same_data_but_convertible_by_mask) {
                    $(this.inputRef).val(newValue).trigger('change');  //inform bootstrap date picker object that value has been changed
                }

                // Updated value if date is inverted due to an mutation(change globally) with date from the api which has
                // dates that have not been formatted according to the tenant.
                if (not_same_data_but_convertible_by_mask && vm.emit_on_update) {
                    vm.changeValue(oldValue); //Simulate a click/typing on the UI in order to correct the value with tenant format
                    vm.emit_on_update = false; //prevent next emit
                }

                if (!vm.emit_on_update) {
                    //prevent looping caused by continuous emitting
                    setTimeout(() => {
                        vm.emit_on_update = true;
                    }, 100); // potentialy convert it to a promius in the future.
                }
            },
            endDate: function (val) {
                let vm = this;
                if (val !== '') {
                    $(vm.inputRef).datepicker('setEndDate', val);
                    vm.settings['endDate'] = val;
                }
            },
            startDate: function (val) {
                let vm = this;
                if (val !== '' && !!vm.hasStartDate && !vm.disallowPast) {
                    $(this.inputRef).datepicker('setStartDate', val);
                    vm.settings['startDate'] = val;
                }
            },
            readonly: function (val) {
                $(this.inputRef).datepicker('destroy');
                this.settings['enableOnReadonly'] = !this.readonly;
                this.init();
            },
            rules: function (val) {
                if(this.required === false) {
                    this.removeErrorClass();
                }
                this.assignRules();
            },
        },
        destroyed: function () {
            $(this.inputRef).off().datepicker('destroy')
        },
        beforeDestroy: function () {
            "use strict";
            $(this.inputRef).datepicker('hide')
            $(this.inputRef).datepicker('destroy')
        }
    }
</script>
<style scoped>
    .pickerEnabled {
        cursor: text;
    }
</style>